import "core-js/modules/es6.number.constructor.js";
import { buildUniqueIdName } from '~/helpers/seo-helpers';
var NavItemTree = function NavItemTree() {
  return import('./NavItemTree.vue');
};
var MdmLink = function MdmLink() {
  return import( /* webpackChunkName: "link-desktop" */'~/components/atoms/MdmLink.vue');
};
export default {
  name: 'NavItemBranch',
  components: {
    NavItemTree: NavItemTree,
    MdmLink: MdmLink
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    withColor: {
      type: Boolean,
      default: false
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false,
      buildUniqueIdName: buildUniqueIdName
    };
  },
  methods: {
    close: function close() {
      if (this.isOpen) {
        this.isOpen = false;
        this.$refs.tree.close();
      }
    }
  }
};